const oldTracker = {
  sendPageView() {
    if (window._gptrq === undefined) {
      return;
    }

    this.sendEvent([
      'pageView'
    ]);
  },
  sendEvent(event) {
    setTimeout(() => {
      window._gptrq.push(event);
    })
  }
};

export default oldTracker;
